var map = {
	"./end_recording.mp3": 3885,
	"./start_recording.mp3": 3886
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 687;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/speech-to-text .\.mp3*
// module id = 687
// module chunks = 0